import { render, staticRenderFns } from "./CustomerDynamics.vue?vue&type=template&id=5bcf56d9&scoped=true&"
import script from "./CustomerDynamics.vue?vue&type=script&lang=js&"
export * from "./CustomerDynamics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDynamics.vue?vue&type=style&index=0&id=5bcf56d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf56d9",
  null
  
)

export default component.exports